import React from 'react'
import SbEditable from 'storyblok-react'
import { CTACard } from '@/components/ui/cta-card'
import RichText from '@/utils/RichText'
import { Button } from '@/components/ui/button'

type TextPositions = 'start' | 'center' | 'end'

export interface SectionTitleProps {
  blok: StoryblokComponent & {
    _uid: string
    use_brightgreen_label: boolean
    label: string
    heading: string
    subheading: string
    content: string
    position: TextPositions
    has_cta: boolean
    cta_label?: string
    cta_ction?: string
  }
}

export const SectionTitle = ({ blok }: SectionTitleProps) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''

  const textPositions: Record<TextPositions, string> = {
    start: 'left',
    center: 'center',
    end: 'right',
  }

  return (
    <div
      className={`font-display w-full flex justify-center`}
      style={{
        marginTop: marginTopClass,
        marginBottom: marginBottomClass,
      }}
    >
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok}>
        <div className={`flex flex-col w-full max-w-6xl  px-6 py-8`}>
          {blok.label && (
            <div
              className={`font-sans uppercase text-sm  tracking-wide font-semibold mb-4 ${blok.use_brightgreen_label ? 'text-brightgreen' : 'text-white'}`}
            >
              {blok.label}
            </div>
          )}

          {/* Title */}
          <div className="prose text-black text-5xl font-bold leading-tight mb-4 max-w-2xl not-prose">
            <RichText>{blok.heading}</RichText>
          </div>

          {blok.subheading && (
            <div className="prose text-2xl font-bold leading-tight mb-4 ">
              <RichText>{blok.subheading}</RichText>
            </div>
          )}

          {/* Content */}
          <div className="prose text-black mt-2 max-w-2xl not-prose">
            <RichText>{blok.content}</RichText>
          </div>

          {blok.has_cta && (
            <div className="mt-8">
              <Button to={blok.cta_action} variant="secondary_blue">
                {blok.cta_label}
              </Button>
            </div>
          )}
        </div>
      </SbEditable>
    </div>
  )
}

SectionTitle.displayName = 'Section Title Block'
